import { useState, useEffect } from 'react';
import { saveOneri, getOneri } from '../services/budgetOneriService';

const BudgetOneriTable = ({ data, cantiereId }) => {
  console.log("🧪 BudgetOneriTable props:", { data, cantiereId });
  const [oneriUrbanizzazione, setOneriUrbanizzazione] = useState('');
  const [oneriScomputo, setOneriScomputo] = useState('');
  const [modificaAttiva, setModificaAttiva] = useState(false);
  const [caricamento, setCaricamento] = useState(true);
  const [oneriData, setOneriData] = useState(null);
  console.log("🧪 DATA in BudgetOneriTable (typeof, value):", typeof data, data);

useEffect(() => {
  const fetchOneri = async () => {
    if (!cantiereId) return;
    try {
      const res = await getOneri(cantiereId);
      setOneriData(res.data);
    } catch (err) {
      console.error('Errore nel recupero oneri:', err);
    } finally {
      setCaricamento(false);
    }
  };
  fetchOneri();
}, [cantiereId]);

useEffect(() => {
  if (oneriData && modificaAttiva) {
    setOneriUrbanizzazione(oneriData.oneri_urbanizzazione || '');
    setOneriScomputo(oneriData.oneri_scomputo || '');
  }
}, [oneriData, modificaAttiva]);

  if (!data || typeof data !== 'object' || Array.isArray(data) || data === false) {
    return <p>⚠️ Errore: dati non validi per il calcolo degli oneri.</p>;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const slp = data?.superficie_slp ? Number(data.superficie_slp) : 0;
    const totaleOneri = (parseFloat(oneriUrbanizzazione || 0) * slp) + (parseFloat(oneriScomputo || 0) * slp);
    const payload = {
      oneri_urbanizzazione: oneriUrbanizzazione,
      oneri_scomputo: oneriScomputo,
      totale_oneri: totaleOneri
    };
    console.log('Dati da salvare:', payload);
    saveOneri(cantiereId, payload)
      .then(data => {
        console.log('Salvataggio riuscito:', data);
        window.location.reload();
      })
      .catch(error => {
        console.error('Errore:', error);
        alert('Errore nel salvataggio');
      });
  };

  if (caricamento) {
    return <p>Caricamento dati oneri...</p>;
  }

  if (!oneriData || modificaAttiva) {
    return (
      <div className="card p-4">
        <h5>Inserisci Oneri di Urbanizzazione</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Oneri di Urbanizzazione (€)</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              value={oneriUrbanizzazione}
              onChange={(e) => setOneriUrbanizzazione(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Oneri a Scomputo (€)</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              value={oneriScomputo}
              onChange={(e) => setOneriScomputo(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary">Salva</button>
        </form>
      </div>
    );
  } else {
    const slp = data && !isNaN(Number(data.superficie_slp)) ? Math.round(Number(data.superficie_slp)) : 0;
    return (
      <div className="card p-4">
        <h5>Oneri di Urbanizzazione</h5>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Voce</th>
                <th>Costo €/mq</th>
                <th>mq (SLP)</th>
                <th>Totale previsto (€)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Oneri di Urbanizzazione</td>
                <td>{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(oneriData.oneri_urbanizzazione || 0))}</td>
                <td>{slp ? new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(slp) : '—'}</td>
                <td>
                  {slp
                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(oneriData.oneri_urbanizzazione || 0) * slp)
                    : '—'}
                </td>
              </tr>
              <tr>
                <td>Oneri a Scomputo</td>
                <td>{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(oneriData.oneri_scomputo || 0))}</td>
                <td>{slp ? new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(slp) : '—'}</td>
                <td>
                  {slp
                    ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(oneriData.oneri_scomputo || 0) * slp)
                    : '—'}
                </td>
              </tr>
              <tr>
                <td><b>TOTALE</b></td>
                <td colSpan={2}></td>
                <td  style={{ fontSize: '1.2rem', fontWeight:'700', color: 'red' }}>
                  {slp
                      ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(oneriData.totale_oneri || 0) * slp)
                      : '—'}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="text-end mt-3">
            <button className="btn btn-warning" onClick={() => setModificaAttiva(true)}>
              ✏️ Modifica Dati
            </button>
          </div>
        </div>
      </div>
    );
  }
};

export default BudgetOneriTable;